export const DELETE_ALL_NOTIFICATION = 'DELETE_ALL_NOTIFICATION'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'
export const DELETE_VAPID_PUBLIC_KEY = 'DELETE_VAPID_PUBLIC_KEY'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
// export const INSERT_NOTIFICATION = 'INSERT_NOTIFICATION'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const SET_REGISTERING_REQUEST_STATUS = 'SET_REGISTERING_REQUEST_STATUS'
export const UPDATE_IS_SW_INSTALLED = 'UPDATE_IS_SW_INSTALLED'
export const UPDATE_VAPID_PUBLIC_KEY = 'UPDATE_VAPID_PUBLIC_KEY'
